import Dexie from "dexie";
import db from "../Db";

var DeleteParam = Dexie.async(function* () {
  yield db.open();
  yield db.PARAM.clear();
});

export default DeleteParam;
